/* global gsap */

/**
 *
 * @param {HTMLElement} element
 * @return {Boolean}
 */
const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

const init = () => {
  const heroGeometrics = document.querySelectorAll('[data-ref="hero-geometric"]');

  if (heroGeometrics && heroGeometrics.length < 1) {
    return;
  }

  heroGeometrics.forEach((heroGeo) => {
    let tl;

    if (isInViewport(heroGeo)) {
      tl = gsap.timeline();
    } else {
      tl = gsap.timeline({
        scrollTrigger: {
          trigger: heroGeo,
          once: true,
          start: 'bottom bottom',
        },
      });
    }

    const heroGrid = heroGeo.querySelector('[data-ref="hero-grid"]');
    const heroText = heroGeo.querySelector('[data-ref="hero-text"]');
    const overlapStart = heroGeo.querySelector('[data-ref="overlap-start"]');
    const overlapEnd = heroGeo.querySelector('[data-ref="overlap-end"]');

    tl.to(heroGrid, {
      autoAlpha: 1,
    }).to(heroText, {
      autoAlpha: 1,
      x: 0,
    }, '<').to(overlapStart, {
      xPercent: -52,
    }, '<').to(overlapEnd, {
      xPercent: 52,
    }, '<');
  });
};

init();
